
















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import SignedTextView from '@/modules/shared/components/shared/SignedTextView.vue'

@Component({
  inheritAttrs: false,
  components: { SignedTextView }
})
export default class CurrencyView extends Vue {
  @Prop({ required: true }) value!: number | string
  @Prop({ default: 'موجودی فعلی' }) prefix: string
  @Prop() prefixClass: string
  @Prop({ default: 'تومان' }) append !: string
  @Prop() appendClass!: string
  @Prop() ltr!: boolean

  get __value() {
    return Number(this.value).toLocaleString()
  }

  private ltrStyle = {
    direction: 'ltr'
  }

}
